import { getSessionInfo, wasAutomaticallyLoggedOut } from './session-store';
export const isLoggedIn = () => {
    if (!getSessionInfo()) {
        return false;
    }
    return !!getSessionInfo().userGUID && !wasAutomaticallyLoggedOut();
};
//# sourceMappingURL=auth.js.map